import { Injectable, ElementRef, EventEmitter, Output } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScrollableService {
  private scrollableElement: ElementRef;

  @Output() scrolled: EventEmitter<number> = new EventEmitter();

  setScrollableElement(element: ElementRef) {
    this.scrollableElement = element;
    this.initScrollListener();
    this.emitScrollEvent();
  }

  getScrollY(): number {
    if (this.scrollableElement) {
      return this.scrollableElement.nativeElement.scrollTop;
    }
    return 0;
  }

  scrollTo(y: number) {
    if (this.scrollableElement) {
      this.scrollableElement.nativeElement.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  private initScrollListener() {
    if (this.scrollableElement) {
      this.scrollableElement.nativeElement.addEventListener('scroll', () => {        
        this.emitScrollEvent();
      });
    }
  }

  private emitScrollEvent() {
    this.scrolled.emit(this.getScrollY());
  }
}